import HomeCarousel from "../../Component/HomeCarouselComponent";
import Carousel from "react-grid-carousel";
import { SRLWrapper } from "simple-react-lightbox";
import ReactPlayer from "react-player";

const activity = [
  {
    id: 2,
    header: "Traveler",
    imageUrl1:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/safari-vehicle.webp",
    imageUrl2:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HowItWorks/IMG-6544.webp",
    imageUrl3:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HowItWorks/resania-travelers-serengeti.webp",
    comment:
      " Resania welcomes all travelers from all over the world to travel with us. You'll have the opportunity to experience wildlife, culture, white sands, hikes on Mount Kilimanjaro and much more that attracts hundreds of thousands of tourists from around the world. The world in one country ",
  },
  {
    id: 3,
    header: "Company",
    imageUrl1:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HowItWorks/swedish-companies.jpg",
    imageUrl2:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HowItWorks/welcome-serengeti.webp",
    comment:
      "We work directly with businesses of all sizes, through which employees will automatically receive a 20% off on all our packages, with the possibility to go on a fruitful working vacation Traveler / companies are welcome to donate or volunteer to motivate or educate our youth ",
  },
  {
    id: 7,
    header: "Activities",
    imageUrl1:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/Kilimanjaro/climbing-kilimanjaro.webp",
    imageUrl2:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/CoreServices/BushToBeach/ZANZIBAR-dining.webp",
    imageUrl3:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HowItWorks/Zambia_RovosRail_KafueBridge.webp",
    imageUrl4:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HowItWorks/resania-travelers-serengeti.webp",
    comment:
      "Resania provides a variety of activities or services that cater to the majority of traveler desires, ranging from classic safari adventure, sightseeing, culture, mountain climbing, train safari across five African countries, snorkeling, swimming with whale sharks, and beach vacations. ",
  },
  {
    id: 4,
    header: "Profit",
    imageUrl1:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HowItWorks/tourims-profit-to-academy.jpg",
    comment:
      "Youth in Tanzania do not have the opportunity to learn the fundamentals of information technology, programming, and electronics. We are passionate about filling that gap by providing free labs where youth can sign up and get this opportunity; we will donate 15% of our tourism profit and direct it to this goal. ",
  },
  {
    id: 1,
    header: "Carbon Removal",
    imageUrl1:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/safari-vehicle.webp",
    imageUrl2:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HowItWorks/IMG-6544.webp",
    imageUrl3:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HowItWorks/resania-travelers-serengeti.webp",
    comment:
      " Removing CO₂ from the atmosphere is critical to counteract climate change, but it’s behind. A fraction of every purchase from Resania helps new carbon removal technologies scale. ",
  },
  {
    id: 5,
    header: "Resania Academy",
    // imageUrl1:
    //   "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HowItWorks/youth-leaning.jpg",
    imageUrl2:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HowItWorks/learn-electronics.jpg",
    comment:
      " The academy will teach the fundamentals of information technology, computer programming, and electronics to youth in both rural and urban areas throughout Tanzania.  We will use our profits from tourism as our primary funding source, and we will collect other resources and materials to make this process smooth and effective. (Webpage underconstruction )",
  },
  {
    id: 6,
    header: "Volunteer / Donation",
    imageUrl1:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HowItWorks/donate-computer.jpg",
    imageUrl2:
      "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HowItWorks/pexels-polina-zimmerman-3747486.jpg",
    readmore: "/resania/resania-academy",
    comment:
      "To be able to reach out to as many youths as possible, a large amount of resources and funds are required; tourism activities can only cover a small portion of this; therefore, we gratefully accept any assistance that will directly affect our progress. ",
  },
];

const HowItWorksComponent = () => {
  return (
    <>
      <HomeCarousel
        image_url={[
          "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/Kilimanjaro/climbing-kilimanjaro.webp",
          "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/hot-air-ballon-serengeti-carousel.jpg",
          "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/cheetah1.jpg",
          "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/resania_car_traveller.webp",
          "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HotelZanzibar/beach.webp",
          'https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/ndarakwai-carousel.webp'
  ]}
        title1="Resania Vision"
        button_text="Social Responsibity"
        description="Our clients will have a once-in-a-lifetime vacation. Educate young people on the fundamentals of science and technology."
        link="/resania/help-plan"
      />

    <div>
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
          <div>
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            At Resania, we contribute 0.5% of our revenue to carbon removal
            </h2>
            <p className="mt-3 max-w-4xl text-base text-gray-500">
            Removing CO₂ from the atmosphere is critical to counteract climate change, but it’s behind. A fraction of every purchase from Resania helps new carbon removal technologies scale.
            </p>
            <div className="mt-8 sm:flex">
              <div className="rounded-md shadow">
                <a
                  href="https://climate.stripe.com/6t9QHZ"
                  className="flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md button-bg text-white hover:text-gray-400"
                >
                Read more
                </a>
              </div>
            </div>
          </div>
          <div className="mt-8 grid grid-cols-2 gap-0.5 md:grid-cols-3 lg:mt-0 lg:grid-cols-2">
            <div className="col-span-1 flex justify-center py-8 px-8 ">
            <img src="https://img.icons8.com/external-wanicon-lineal-color-wanicon/64/000000/external-carbon-dioxide-innovative-renewable-energy-wanicon-lineal-color-wanicon.png" alt="Safari"/>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div >
      <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-base font-semibold text-color tracking-wide uppercase">how we work</h2>
          <p className="mt-1 text-3xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-5xl">
          Business Life Cycle
          </p>
          <p className="max-w-5xl mt-5 mx-auto text-base text-gray-500">
            Every journey with us counts, we acknowledge that people and nature are inseparable partners, so we work closely with communities, authorities, NGOs and industry partners to achieve the best possible long-term outcomes for all concerned
          </p>
        </div>
      </div>
    </div>

      <div className="container mt-20 mb-20">
        <div>
        <ReactPlayer url="https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/Video/how_it_works_2.mp4" width='100%' playing={true} light loop />
          <div
            className="absolute inset-0 bg-gray-50 mix-blend-multiply"
            aria-hidden="true"
          />
        </div>
        <br />
        <div className="flow-root">
          <ul className="-mb-8 list-none">
            {activity.map((activityItem) => (
              <li key={activityItem.id}>
                <div className="dark:bg-gray-800 pt-16 lg:py-24">
                  <div className="pb-16 bg-gray-100 dark:bg-gray-800 lg:pb-0 lg:z-10 lg:relative">
                    <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-3 lg:gap-8">
                      <div className="relative lg:-my-8">
                        <div
                          aria-hidden="true"
                          className="absolute inset-x-0 top-0 h-1/2 bg-white lg:hidden"
                        />
                        <div className="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:p-0 lg:h-full">
                          <div className="aspect-w-10 aspect-h-6 rounded-xl shadow-xl overflow-hidden sm:aspect-w-16 sm:aspect-h-7 lg:aspect-none lg:h-full">
                            <SRLWrapper>
                              <Carousel cols={1} rows={1} gap={10}>
                                {activityItem.imageUrl1 && (
                                  <Carousel.Item>
                                    <img
                                      alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                                      title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                                      className="object-center object-cover lg:h-96"
                                      src={activityItem.imageUrl1}
                                      width="100%"
                                      height="400px"
                                    />
                                  </Carousel.Item>
                                )}
                                {activityItem.imageUrl2 && (
                                  <Carousel.Item>
                                    <img
                                      alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                                      title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                                      className="object-center object-cover lg:h-96"
                                      src={activityItem.imageUrl2}
                                      width="100%"
                                      height="400px"
                                    />
                                  </Carousel.Item>
                                )}
                                {activityItem.imageUrl3 && (
                                  <Carousel.Item>
                                    <img
                                      alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                                      title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                                      className="object-center object-cover lg:h-96"
                                      src={activityItem.imageUrl3}
                                      width="100%"
                                      height="400px"
                                    />
                                  </Carousel.Item>
                                )}
                                {activityItem.imageUrl4 && (
                                  <Carousel.Item>
                                    <img
                                      alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                                      title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                                      className="object-center object-cover lg:h-96"
                                      src={activityItem.imageUrl4}
                                      width="100%"
                                      height="400px"
                                    />
                                  </Carousel.Item>
                                )}
                              </Carousel>
                            </SRLWrapper>
                          </div>
                        </div>
                      </div>
                      <div className="mt-12 lg:m-0 lg:col-span-2 lg:pl-8">
                        <div className="mx-auto max-w-md px-4 sm:max-w-2xl sm:px-6 lg:px-0 lg:py-20 lg:max-w-none">
                          <div>
                            <p className="mt-6 font-medium">
                              {activityItem.comment}
                            </p>
                          </div>
                          <footer className="mt-6">
                            <h2 className="font-bold text-3xl">
                              {activityItem.header}
                            </h2>
                          </footer>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
          <br />
        </div>
      </div>
    </>
  );
};

export default HowItWorksComponent;
